<template>
  <div class="wrap-gross-net">
    <button class="blue-button fz14 fw500" v-if="!showInfo" v-on:click="showInfo = true">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18.6C15.6451 18.6 18.6 15.6451 18.6 12C18.6 8.35492 15.6451 5.4 12 5.4C8.35492 5.4 5.4 8.35492 5.4 12C5.4 15.6451 8.35492 18.6 12 18.6ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" fill="white"/>
        <path d="M11.794 16.9C11.7207 16.9 11.6583 16.8743 11.607 16.823C11.5557 16.7717 11.53 16.7093 11.53 16.636V15.866C10.9873 15.8147 10.529 15.6863 10.155 15.481C9.781 15.2683 9.49867 15.0153 9.308 14.722C9.11733 14.4213 9.01467 14.1097 9 13.787C9 13.721 9.022 13.666 9.066 13.622C9.11733 13.578 9.176 13.556 9.242 13.556H10.221C10.309 13.556 10.3787 13.578 10.43 13.622C10.4813 13.6587 10.5217 13.7063 10.551 13.765C10.6023 13.9043 10.6867 14.0437 10.804 14.183C10.9287 14.315 11.101 14.425 11.321 14.513C11.541 14.601 11.816 14.645 12.146 14.645C12.674 14.645 13.0663 14.557 13.323 14.381C13.5797 14.205 13.708 13.9667 13.708 13.666C13.708 13.4533 13.6383 13.2847 13.499 13.16C13.367 13.028 13.1543 12.9107 12.861 12.808C12.5677 12.698 12.1827 12.5843 11.706 12.467C11.1633 12.335 10.705 12.1773 10.331 11.994C9.957 11.8033 9.67467 11.565 9.484 11.279C9.30067 10.993 9.209 10.63 9.209 10.19C9.209 9.62533 9.41433 9.145 9.825 8.749C10.2357 8.353 10.804 8.111 11.53 8.023V7.264C11.53 7.19067 11.5557 7.12833 11.607 7.077C11.6583 7.02567 11.7207 7 11.794 7H12.465C12.5383 7 12.6007 7.02567 12.652 7.077C12.7033 7.12833 12.729 7.19067 12.729 7.264V8.045C13.2277 8.11833 13.6457 8.265 13.983 8.485C14.3203 8.705 14.577 8.958 14.753 9.244C14.929 9.52267 15.0207 9.794 15.028 10.058C15.028 10.1167 15.006 10.1717 14.962 10.223C14.9253 10.267 14.8703 10.289 14.797 10.289H13.774C13.708 10.289 13.6457 10.2743 13.587 10.245C13.5283 10.2157 13.4807 10.1607 13.444 10.08C13.4073 9.85267 13.268 9.65833 13.026 9.497C12.784 9.33567 12.4687 9.255 12.08 9.255C11.684 9.255 11.365 9.32833 11.123 9.475C10.8883 9.62167 10.771 9.849 10.771 10.157C10.771 10.3623 10.8297 10.5347 10.947 10.674C11.0643 10.806 11.255 10.9233 11.519 11.026C11.7903 11.1287 12.1497 11.2387 12.597 11.356C13.2203 11.4953 13.7263 11.6567 14.115 11.84C14.511 12.0233 14.8007 12.258 14.984 12.544C15.1747 12.8227 15.27 13.1783 15.27 13.611C15.27 14.0363 15.1637 14.4103 14.951 14.733C14.7457 15.0483 14.4523 15.305 14.071 15.503C13.6897 15.6937 13.2423 15.8183 12.729 15.877V16.636C12.729 16.7093 12.7033 16.7717 12.652 16.823C12.6007 16.8743 12.5383 16.9 12.465 16.9H11.794Z" fill="white"/>
      </svg>
      Profit/Loss
    </button>
    <div class="info" v-if="showInfo">
      <button class="close-info" v-on:click="showInfo = false">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.51375 7.57727C6.21612 7.28258 6.21612 6.80478 6.51375 6.51008C6.81138 6.21539 7.29392 6.21539 7.59155 6.51008L17.4863 16.2961C17.784 16.5908 17.784 17.0685 17.4863 17.3632C17.1887 17.6579 16.7062 17.6579 16.4085 17.3632L6.51375 7.57727Z" fill="#2C2C2C"/>
          <path d="M16.4086 6.634C16.7063 6.33931 17.1888 6.33931 17.4864 6.634C17.7841 6.9287 17.7841 7.4065 17.4864 7.70119L7.59165 17.4872C7.29402 17.7819 6.81148 17.7819 6.51385 17.4872C6.21622 17.1925 6.21622 16.7147 6.51385 16.42L16.4086 6.634Z" fill="#2C2C2C"/>
        </svg>
      </button>
      <div class="flex align-items-center justify-between">
        <p class="fz13 text-dark-gray">Profit / Loss, USD:</p>
        <p class="fz13 text-dark fw700">{{amountProfit | formatNumberTwo}}</p>
      </div>
      <div class="flex align-items-center justify-between mt8">
        <p class="fz13 text-dark-gray">Net Profit / Loss, USD:</p>
        <p class="fz13 text-dark fw700">{{amountNetProfit | formatNumberTwo}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "payment-gross-net",
  data() {
    return {
      showInfo: false,
    }
  },
  computed: {
    ...mapState({
      amountProfit: state => state.payment.amountProfit,
      amountNetProfit: state => state.payment.amountNetProfit,
    })
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
  .wrap-gross-net {
    z-index: 20;
    position: fixed;
    bottom: 24px;
    right: 24px;
    .blue-button {
      width: 140px;
      height: 32px;
    }
  }
  .info {
    width: 326px;
    height: 64px;
    background: var(--color-bgc-page);
    border: 1px solid var(--color-border);
    box-sizing: border-box;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.24);
    border-radius: 4px;
    padding: 12px 16px 12px 44px;
  }
  .close-info {
    position: absolute;
    top: 8px;
    left: 8px;
  }
</style>